import * as React from 'react';
import { TOnSlideChangeParams } from '@cian/frontend-newbuilding-carousel-component';
import { useSelector } from 'react-redux';
import { ConstructionProgress } from '../../components/ConstructionProgress';
import { prepareImages } from '../../components/ConstructionProgress/utils';
import { FullscreenSliderGallery } from '../../components/FullscreenSliderGallery';
import { Layout } from '../../components/Layout';

import { getConstructionProgress, getConstructionProgressUrl, getDisplayName } from '../../selectors/newbuilding';
import { trackConstructionProgressClick } from './analytics';
import { CONSTRUCTION_PROGRESS_FULLSCREEN_SETTINGS } from './settings';

export function ConstructionProgressContainer() {
  const [isFullscreenOpened, toggleFullscreen] = React.useState(false);
  const [currentSlide, changeSlide] = React.useState(0);

  const url = useSelector(getConstructionProgressUrl);
  const constructionProgress = useSelector(getConstructionProgress);
  const name = useSelector(getDisplayName);

  const onItemClick = React.useCallback((index: number) => {
    toggleFullscreen(true);
    changeSlide(index + 1);
    trackConstructionProgressClick();
  }, []);

  const onFullscreenClose = React.useCallback(() => {
    toggleFullscreen(false);
  }, []);

  const onSlideChange = React.useCallback(({ currentSlide }: TOnSlideChangeParams) => {
    changeSlide(currentSlide);
  }, []);

  if (!constructionProgress) {
    return null;
  }

  const { updateDateTitle, images } = constructionProgress;

  return (
    <Layout>
      <ConstructionProgress
        newbuildingName={name}
        updated={updateDateTitle}
        images={images}
        url={url}
        onLinkClick={trackConstructionProgressClick}
        onItemClick={onItemClick}
      />
      {isFullscreenOpened && (
        <FullscreenSliderGallery
          images={prepareImages(images)}
          currentSlide={currentSlide}
          onClose={onFullscreenClose}
          onSlideChange={onSlideChange}
          settings={CONSTRUCTION_PROGRESS_FULLSCREEN_SETTINGS}
        />
      )}
    </Layout>
  );
}
